import { render, staticRenderFns } from "./TechnicalDashboardMain.vue?vue&type=template&id=fc4cd3f2"
import script from "./TechnicalDashboardMain.vue?vue&type=script&lang=js"
export * from "./TechnicalDashboardMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports